/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompagename2Inputs */

const en_entity_custompagename2 = /** @type {(inputs: Entity_Custompagename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page Name`)
};

const de_entity_custompagename2 = /** @type {(inputs: Entity_Custompagename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Custom Page Name" |
*
* @param {Entity_Custompagename2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompagename2 = /** @type {((inputs?: Entity_Custompagename2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompagename2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompagename2(inputs)
	return de_entity_custompagename2(inputs)
});
export { entity_custompagename2 as "entity_customPageName" }